import React,{useState,useEffect} from "react";
import API from "../../utils/API";
import {AvField} from "availity-reactstrap-validation";

const UserStatus = ({name,value,onChange}) => {
    const [data,setData] = useState(null)

    useEffect(() => {
        API.get('/admin/system/userstatus').then((response) => {
            setData(response.data.data)
        });
    }, [])

    return (
        <select
            name={name}
            value={value}
            onChange={(e)=>onChange(name,e.target.value)}
            className="form-control"
        >
            <option value="">Select...</option>
            {data &&
                data.map((dataItem, index) => (
                    <option key={index} selected={value === dataItem.id} value={dataItem.id}>{dataItem.title}</option>
                ))
            }
        </select>
    )
}

export default UserStatus;
